export enum Role {
  SUPER_ADMIN = 'superAdmin',
  PHARMACY_ADMIN = 'admin',
  PHARMACY_DISPENSER = 'homecareDispenser',
  PHARMACY_DRIVER = 'driver',
  LOGISTICS_ADMIN = 'logisticsAdmin',
  LOGISTICS_DRIVER = 'logisticsDriver',
  TRANSPORT_ADMIN = 'transportAdmin',
  TRANSPORT_DRIVER = 'transportDriver',
}

export const Roles: IRole[] = [
  {
    label: 'Pharmacy Admin',
    key: Role.PHARMACY_ADMIN,
  },
  {
    label: 'Pharmacy Dispenser',
    key: Role.PHARMACY_DISPENSER,
  },
  {
    label: 'Pharmacy Driver',
    key: Role.PHARMACY_DRIVER,
  },
  {
    label: 'Logistics Admin',
    key: Role.LOGISTICS_ADMIN,
  },
  {
    label: 'Logistics Driver',
    key: Role.LOGISTICS_DRIVER,
  },
  {
    label: 'Super Admin',
    key: Role.SUPER_ADMIN,
  },
  {
    label: 'Transport Admin',
    key: Role.TRANSPORT_ADMIN,
  },
  {
    label: 'Transport Driver',
    key: Role.TRANSPORT_DRIVER,
  },
];

export const getRoleFromKey = (key: string) => {
  const role = Roles.find((role) => role.key === key);
  return role;
};

export const getRoleNameFromKey = (key: string) => {
  const role = Roles.find((role) => role.key === key);
  return role?.label ?? 'Unknown';
};

export const getRoleFromName = (name: string) => {
  const role = Roles.find((role) => role.label === name);
  return role;
};

export interface IRouteRoles {
  roles?: Role[];
}

export interface IRole {
  label: string;
  key: Role;
}
